import React from 'react';

import s from './WideWidgetLayout.scss';

export interface Props {
  header?: string;
  subSubheader?: string;
  navigation: React.ReactNode;
  headerExtras?: React.ReactNode | React.ReactNode[];
  children: React.ReactNode;
}

export const WideWidgetLayout: React.FC<Props> = ({
  header,
  subSubheader,
  headerExtras,
  navigation,
  children,
}) => {
  return (
    <div className={s['root']}>
      <div className={s['navigation']}>{navigation}</div>
      <div className={s['content-column']}>
        {header && (
          <h1 className={s['header']}>
            <div>{header}</div>
            {headerExtras}
          </h1>
        )}
        {subSubheader && <div className={s['subheader']}>{subSubheader}</div>}
        <div className={s['widgets']}>{children}</div>
      </div>
    </div>
  );
};
WideWidgetLayout.displayName = 'WideWidgetLayout';

export default WideWidgetLayout;
